let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("893Pl")).then(() => parcelRequire('8RYqC'));